import { createSlice } from '@reduxjs/toolkit';
import storage from '../utils/storage';

const initialState = {
  '1': { complete: true, path: '/' },
  '2': { complete: false, path: '/plano-gateway' },
  '3': { complete: true, path: '/frequencia-gateway' },
  '4': { complete: true, path: '/metodo-de-preparo' },
  '5': { complete: false, path: '/entrega' },
  '6': { complete: false, path: '/pagamento' },
}

const cachedSteps = storage.get('steps') || {};

export const stepsSlice = createSlice({
  name: 'steps',
  initialState: { ...initialState, ...cachedSteps },
  reducers: {
    completeStep: (state, action) => {
      if(state[action.payload]) state[action.payload].complete = true

      storage.set('steps', state);
    },
    resetSteps: (state, action) => {
      storage.set('steps', initialState);
      return initialState;
    },
  },
});

export const { completeStep, resetSteps } = stepsSlice.actions;

export default stepsSlice.reducer;
